/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { render } from "react-dom";
import DeckGL, {
  COORDINATE_SYSTEM,
  PointCloudLayer,
  OrbitView,
  LinearInterpolator
} from "deck.gl";

// @ts-ignore
import { LASWorkerLoader } from "@loaders.gl/las";
// @ts-ignore
import { PLYWorkerLoader } from "@loaders.gl/ply";
// @ts-ignore
import { load, registerLoaders } from "@loaders.gl/core";
import { Wave } from "react-preloading-component";

const transitionInterpolator = new LinearInterpolator(["rotationOrbit"]);

const INITIAL_VIEW_STATE = {
  target: [0, 0, 0],
  rotationX: 0,
  rotationOrbit: 0,
  orbitAxis: "Y",
  fov: 10,
  minZoom: 0,
  maxZoom: 20,
  zoom: 9
};

registerLoaders(PLYWorkerLoader);

class PointCloudViewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewState: INITIAL_VIEW_STATE,
      pointsCount: 0,
      dataFile: "./data/db663e3f7ee9869f5c351e299b24e355.ply",
      points: null,
      pointSize: 0.4,
      isLoading: true,
      loadingText: "LOADING DATA"
    };

    this._onLoad = this._onLoad.bind(this);
    this._onViewStateChange = this._onViewStateChange.bind(this);
    this._rotateCamera = this._rotateCamera.bind(this);
    this.increasePointSize = this.increasePointSize.bind(this);
    this.decreasePointSize = this.decreasePointSize.bind(this);

    load(this.props.data).then(this._onLoad);
  }

  increasePointSize() {
    this.setState({ pointSize: this.state.pointSize + 0.2 }, () => {
      //Animation
    });
  }

  decreasePointSize() {
    console.log("this.state.pointSize: " + this.state.pointSize);
    if (this.state.pointSize < 0.4) {
      //do nothing
      console.log("STOPP!!!!");
    } else {
      this.setState({ pointSize: this.state.pointSize - 0.2 }, () => {
        //Animation
      });
    }
  }

  /*
  componentWillReceiveProps(nextProps) {
    this.setState({ dataFile: nextProps.data }, () => {
      let PLY_SAMPLE = this.state.dataFile;
      load(PLY_SAMPLE).then(this._onLoad);
    });
  }
*/

  _onViewStateChange({ viewState }) {
    this.setState({ viewState });
  }

  _rotateCamera() {
    const { viewState } = this.state;
    this.setState({
      viewState: {
        ...viewState,
        rotationOrbit: viewState.rotationOrbit + 30,
        transitionDuration: 600,
        transitionInterpolator,
        onTransitionEnd: this._rotateCamera
      }
    });
  }

  _onLoad({ header, loaderData, attributes, progress }) {
    // metadata from LAZ file header
    const { mins, maxs } = loaderData.header;
    let { viewState } = this.state;

    if (mins && maxs) {
      // File contains bounding box info
      viewState = {
        ...viewState,
        target: [
          (mins[0] + maxs[0]) / 2,
          (mins[1] + maxs[1]) / 2,
          (mins[2] + maxs[2]) / 2
        ],
        /* global window */
        zoom: Math.log2(window.innerWidth / (maxs[0] - mins[0])) - 1
      };
    }

    if (this.props.onLoad) {
      this.props.onLoad({ count: header.vertexCount, progress: 1 });
    }

    this.setState(
      {
        pointsCount: header.vertexCount,
        points: attributes.POSITION.value,
        viewState,
        isLoading: false,
        loadingText: ""
      }
      //this._rotateCamera
    );
  }

  _renderLayers() {
    const { pointsCount, points } = this.state;

    return [
      points &&
        new PointCloudLayer({
          id: "ply-point-cloud-layer",
          coordinateSystem: COORDINATE_SYSTEM.IDENTITY,
          numInstances: pointsCount,
          instancePositions: points,
          getNormal: [0, 1, 0],
          //getColor: [255, 255, 255],
          getColor: [200, 255, 255],
          opacity: 0.5,
          pointSize: this.state.pointSize
        })
    ];
  }

  render() {
    const { viewState } = this.state;

    return (
      <div className="background">
        <DeckGL
          views={new OrbitView()}
          viewState={viewState}
          controller={true}
          onViewStateChange={this._onViewStateChange}
          layers={this._renderLayers()}
          parameters={
            {
              //clearColor: [0.07, 0.14, 0.19, 1]
              //clearColor: ff0000
            }
          }
        />

        {this.state.isLoading ? (
          <div className="loading">
            <h1>{this.state.loadingText}</h1>
            <Wave color="#ffffff" />
          </div>
        ) : (
          <div className="rightNav">
            <div className="small-text"> NO OF POINTS </div>
            <div className="points">{this.state.pointsCount}</div>

            <div className="small-text"> ZOOM LEVEL </div>
            <div className="small-stats">
              {Math.round(this.state.viewState.zoom * 100) / 100}
            </div>
            <button onClick={this.decreasePointSize}> - Point Size</button>
            <button onClick={this.increasePointSize}> + Point Size</button>
          </div>
        )}
      </div>
    );
  }
}

export default PointCloudViewer;
/*
export function renderToDOM(container) {
  render(<PointCloudViewer />, container);
}
*/
